export default function resolveCertificationKind(kind) {
  if (kind === 'HANDLOWIEC') return 'Doradca ds. sprzedaży'
  if (kind === 'HEAD_OF_SALES') return 'Kierownik sprzedaży'
  return 'Nieznany rodzaj'
}
